import axios from 'axios';

import { IPoints } from '@/shared/model/points.model';

const baseApiUrl = 'api/points';

export default class PointsService {
  public findByHeaderId(id: number, checkListTypeId: string): Promise<IPoints> {
    let cod: string = id.toString();
    cod = cod.concat('|');
    cod = cod.concat(checkListTypeId);

    return new Promise<IPoints>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${cod}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
